import React from 'react';

const BackgroundImage: React.FC = () => {
  return (
    <div
      className="fixed inset-0 z-[-3] pointer-events-none"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/img_fond.jpg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
      }}
    />
  );
};

export default BackgroundImage;

